import { defaultTo } from 'lodash'
import {
  ExtraChargeModel,
  PaymentBasicDataDto,
  PaymentViewModel,
  CheckoutPaymentData,
  CheckoutPaymentDataDto,
} from '$domain/model/payment/payment.model'
import * as dayjs from 'dayjs'
import { OneTimePremiumPlan, OneTimePremiumPlanDto } from '$domain/model/premium/premium.model'
import { ProSubscriptionPlan, ProSubscriptionPlanDto } from '$domain/model/pro/pro.model'
import { DateModel, DateModelDto } from '$domain/model/recommendation/calculateBudget/calculateBudget.model'
import { formatDateWithSlashes } from '$utils/dateFormatter'

const mapServiceDates = dates => {
  return dates.map(serviceDates => {
    return {
      startingDateTime: dayjs(serviceDates.startingDateTime).toDate(),
      finishingDateTime: dayjs(serviceDates.finishingDateTime).toDate(),
    }
  })
}

const getPrice = (basicData: PaymentBasicDataDto) => (basicData.price ? basicData.price / 100 : 0)

export const basicDataResponseToModel = (basicData: PaymentBasicDataDto): PaymentViewModel => {
  return {
    caretaker: {
      userId: defaultTo(basicData.userId, ''),
      caretakerId: defaultTo(basicData.caretakerId, ''),
      hasActiveProSubscription: defaultTo(basicData.hasActiveProSubscription, false),
      requestId: defaultTo(basicData.requestId, ''),
      name: defaultTo(basicData.name, ''),
      rating: defaultTo(basicData.rating, 0),
      ratingAmount: defaultTo(basicData.ratingAmount, 0),
      profilePicture: defaultTo(basicData.profilePicture, ''),
      location: defaultTo(basicData.town, ''),
      languages: defaultTo(basicData.languages, []),
      mainQualification: {
        type: defaultTo(basicData.qualificationType, ''),
        specialty: defaultTo(basicData.qualificationSpecialty, ''),
        area: defaultTo(basicData.qualificationArea, ''),
        qualificationName: defaultTo(basicData.qualificationName, ''),
      },
      price: getPrice(basicData),
      caretakerHourlyRate: defaultTo(basicData.caretakerHourlyRate, 0),
    },
    service: {
      serviceDates: defaultTo(mapServiceDates(basicData.serviceDates), []),
      serviceLength: defaultTo(basicData.serviceLength, 0),
      location: defaultTo(basicData.serviceLocation, ''),
      caredType: defaultTo(basicData.caredType, 0),
      age: defaultTo(basicData.age, 0),
      isRecommendation: false,
      nameOfSelectedCaretaker: '',
      isClientSelectedCaretakerAvailable: false,
      residentName: defaultTo(basicData.residentName, ''),
      residentSurname: defaultTo(basicData.residentSurname, ''),
      budgetFee: defaultTo(basicData.budgetFee / 100, 0),
      basePrice: defaultTo(basicData.basePrice / 100, 0),
    },
  }
}

export const convertEurosToCents = (extraCharge: ExtraChargeModel) => {
  return {
    amount: defaultTo(extraCharge.amount * 100, 0),
    concept: defaultTo(extraCharge.concept, ''),
  }
}

export const mapOneTimePremiumPaymentToDto = selectedPlan => {
  if (selectedPlan === OneTimePremiumPlan.oneWeek) {
    return OneTimePremiumPlanDto.oneWeek
  }
  if (selectedPlan === OneTimePremiumPlan.oneMonth) {
    return OneTimePremiumPlanDto.oneMonth
  }
  if (selectedPlan === OneTimePremiumPlan.oneYear) {
    return OneTimePremiumPlanDto.oneYear
  }

  return ''
}

export const mapProSubscriptionPaymentToDto = selectedPlan => {
  if (selectedPlan === ProSubscriptionPlan.monthly) {
    return ProSubscriptionPlanDto.monthly
  }
  if (selectedPlan === ProSubscriptionPlan.yearly) {
    return ProSubscriptionPlanDto.yearly
  }

  return ''
}

export const mapDates = (dates: DateModel[]): DateModelDto[] => {
  if (dates) {
    return dates.map(date => {
      return { date: formatDateWithSlashes(date.date), hours: date.hours }
    })
  }

  return undefined
}

export const mapCheckoutPaymentDataToDto = (paymentData: CheckoutPaymentData): CheckoutPaymentDataDto => {
  return {
    requestId: paymentData.requestId ? paymentData.requestId : '',
    serviceDates: mapDates(paymentData.dates),
    address: paymentData.location.address ? paymentData.location.address : '',
    latitude: paymentData.location.latitude ? paymentData.location.latitude : 0,
    longitude: paymentData.location.longitude ? paymentData.location.longitude : 0,
    province: paymentData.location.province ? paymentData.location.province : 'province',
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/payment/payment.mapper.ts